import promoApi from './api';
import * as types from './actionTypes';

export const getSources = () => {
  return (dispatch, getState) => {
    if (getState().promo.promoSources.length) return;
    dispatch({ type: types.FETCH_COUPON_SOURCES });
    return promoApi
      .getPromoSources()
      .then(data => {
        return dispatch({ type: types.FETCH_COUPON_SOURCES_SUCCESS, payload: data.items });
      })
      .catch(() => {
        return dispatch({ type: types.FETCH_COUPON_SOURCES_FAILURE });
      });
  };
};

export const generateCoupon = sourceName => {
  return async (dispatch, getState) => {
    const sources = getState().promo.promoSources;
    if (!sources.length) {
      await dispatch(getSources());
      if (getState().promo.promoSources.length) {
        dispatch(generateCoupon(sourceName));
        return;
      }
    }
    dispatch({ type: types.GENERATE_COUPON });

    const sourceId = sources.find(s => s.name === sourceName)?.id;
    if (!sourceId) return dispatch({ type: types.GENERATE_COUPON_SOURCE_NOT_FOUND });

    return promoApi
      .generateCoupon({ source_id: sourceId, withError: false })
      .then(data => {
        return dispatch({ type: types.GENERATE_COUPON_SUCCESS, payload: data.coupon });
      })
      .catch(() => {
        dispatch({ type: types.GENERATE_COUPON_FAILURE });
      });
  };
};
